<template>
    <b-card class="border-0 h-100" body-class="d-flex flex-column justify-content-between align-items-middle">
        <div>
            <p style="text-align: center; font-size: 44px; color: #cbd5e1" class="my-4"><font-awesome-icon :icon="icon"/></p>
            <p style="font-size: 15px" class="pt-4">{{ description }}</p>
        </div>
        <b-button variant="outline-primary" class="mt-4" pill block @click="$event => $emit('click', $event)">{{ buttonText }}</b-button>
    </b-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/OptionBlock.vue